import { render, staticRenderFns } from "./OOperationLoaderComp.vue?vue&type=template&id=2fae8144&"
import script from "./OOperationLoaderComp.vue?vue&type=script&lang=js&"
export * from "./OOperationLoaderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports